import tippy from 'tippy.js'
import custom from './custom'

tippy('.tooltip', {
    placement: 'bottom',
    interactive: true,
    delay: [0, 500]
});
